import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "../css/AppChrome.css";

const AppFooter: React.FC = () => {
  const year = useMemo(() => new Date().getFullYear(), []);
  return (
    <footer className="lp2__footer">
      <div className="lp2__container lp2__footerInner">
        <div>© {year} BootLoop</div>
        <div className="lp2__footerLinks">
          <Link to="/dashboard">Dashboard</Link>
          <Link to="/list-boots">List boots</Link>
          <Link to="/find-swap-v2">Find a swap</Link>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
